/**
 * A swiss army knife tool for common functionalities.
 * @module services/utilities
 */

 import _ from "lodash";
 import sToast from "@/services/sToast";
 
 let utilities = {
   downloadFileFromB64,
   downloadFileFromURL
 };
 
 export default utilities;
 
 /**
  * Method to download a file from given url.
  *
  * @author Pranav Jindal
  * @param {string} fileUrl URL to download file from
  * @param {string} [fileName] File name (with extension) to be given to downloaded file.
  * If not provided, name will be extracted from URL.
  * @returns Promise which is resolved on sile download success and rejected on failure.
  */
 function downloadFileFromURL(fileUrl: string, fileName?: string) {
   return import("file-saver")
     .then(fileSaver => {
       return new Promise((resolve, reject) => {
         var extractedFileName = fileUrl;
         var xhr = new XMLHttpRequest();
         xhr.responseType = "blob";
         xhr.onload = function() {
           fileSaver.saveAs(xhr.response, fileName || extractedFileName);
           resolve();
         };
 
         xhr.onerror = function(error:any) {
           sToast.show({
             message: "Something went wrong, please try again later.",
             intent: "error",
             timeout: 5000
           });
         };
         xhr.open("GET", fileUrl);
         xhr.send();
       });
     })
     .catch(networkError);
 }
 
 /**
  * Method to download file from Base64 content.
  *
  * @author CH-E01385 - Pranav Jindal
  * @param {string} b64Content Base 64 content.
  * @param {string} name File name (with extension) to be given to downloaded file.
  * @param {string} [contentType=""] Content type of B64 content.
  * @returns A Promise when file is downloaded.
  */
 function downloadFileFromB64(
   b64Content: string,
   name: string,
   contentType = ""
 ) {
   return import("file-saver")
     .then(fileSaver => {
       let byteArrays: any = [];
       let sliceSize = 512;
       let byteCharacters = atob(b64Content);
 
       for (
         let offset = 0;
         offset < byteCharacters.length;
         offset += sliceSize
       ) {
         let slice = byteCharacters.slice(offset, offset + sliceSize);
         let byteNumbers = new Array(slice.length);
         for (let i = 0; i < slice.length; i++) {
           byteNumbers[i] = slice.charCodeAt(i);
         }
         byteArrays.push(new Uint8Array(byteNumbers));
       }
 
       let blob = new Blob(byteArrays, { type: contentType });
       fileSaver.saveAs(blob, name);
     })
     .catch(networkError);
 }
 
 function networkError() {
   sToast.show({
     message: "networkIssue",
     intent: "error"
   });
 }
 